import { render, staticRenderFns } from "./LoginMagicLink.vue?vue&type=template&id=24d27940&"
import script from "./LoginMagicLink.vue?vue&type=script&lang=js&"
export * from "./LoginMagicLink.vue?vue&type=script&lang=js&"
import style0 from "./LoginMagicLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports